import script from './SdsCarouselDot.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sds-carousel-dot sds-focus",class:{ 'is-active': _vm.isActive },attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}})};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-1ca63c23_0", { source: ".sds-carousel-dot[data-v-1ca63c23]{position:relative;width:20px;height:20px;margin:0;padding:0;background:0 0;border:none;border-radius:50%;outline:0;cursor:pointer}.sds-carousel-dot[data-v-1ca63c23]::before{content:\"\";position:absolute;top:calc(50% - 3px);left:calc(50% - 3px);display:inline-block;width:6px;height:6px;background-color:var(--system-graphics-on-elevation-disabled);border-radius:50%;transition:transform 120ms ease-in-out}.sds-carousel-dot[data-v-1ca63c23]:hover::before{background-color:var(--system-graphics-on-elevation-tertiary-on-body)}.sds-carousel-dot.is-active[data-v-1ca63c23]::before{background-color:var(--system-graphics-on-elevation-brand);transform:scale(1.67)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-1ca63c23";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
